"use client";

import ContactForm from "@/components/frontend/contact/ContactForm";
import { Mail, MapPin, Phone, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import Newsletter from "@/components/frontend/newsletter/Newsletter";
import NewsletterSection from "@/components/frontend/newsletter/Server/NewsLetterSection";

// animations 
const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3, // delay between h2 and p
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export default function Contact() {
    return (
        <>
            <div className="flex flex-col relative items-center justify-center w-full"
                style={{backgroundImage: "url('/images/backk.jpg')", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center center"}}>

                <div className="absolute inset-0 bg-primary/55 h-full" />

                <motion.div
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.4 }}
                    className="flex relative w-full">
                    <div className="flex flex-4 h-full md:pt-10">
                        <motion.div
                            variants={staggerContainer} 
                            className="flex flex-col items-center justify-end px-4 md:px-0 pt-40 pb-20 md:pb-30 gap-0 w-full text-white">
                            <motion.h2 
                                variants={fadeUp}
                                className="text-[38px] md:text-[64px] font-medium font-lora">Get in touch</motion.h2>
                            <motion.p
                                variants={fadeUp} 
                                className="text-lg md:text-xl w-full md:w-[38%] text-center font-light">Do you have a question for our team, or would you like to make an appointment? You can reach us through the options below.</motion.p>
                        </motion.div>
                    </div>
                </motion.div>
            </div>

            <div className="w-full md:py-15">
                <div className="flex md:px-50">
                    <div className="flex flex-col md:flex-row border-1 border-gray-300">
                        {/* Left Column - Office Info */}
                        <div className="flex-1 h-full items-center justify-center text-black rounded-md space-y-8">
                            <div className="flex flex-col md:p-18 md:pl-20 px-5 md:px-0 py-10 gap-15">

                                {/* Nakuru Office */}
                                <div className="flex flex-col">
                                    <h2 className="text-2xl font-bold text-primary uppercase mb-6">Head Office</h2>
                                    <div className="space-y-4">
                                        <div className="flex items-start gap-3">
                                            <MapPin className="mt-1" size={24} />
                                            <p className="text-[18px]">3rd Floor, Assumption Centre, Stadium road. <br />P.O Box 2779-20100, Nakuru, Kenya</p>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <Phone size={22} />
                                            <p className="text-[18px]">0739 707 395 / 0700 572 092</p>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <Mail size={22} />
                                            <p className="text-[18px]">nkr@mmmnlaw.org</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Mombasa Office */}
                                <div className="flex flex-col">
                                    <h2 className="text-2xl font-bold text-primary uppercase mb-6">Mombasa Office</h2>
                                    <div className="space-y-4">
                                        <div className="flex items-start gap-3">
                                            <MapPin className="mt-1" size={24} />
                                            <p className="text-[18px]">4th Floor, Ralli House, Nyerere Avenue. <br />P.O Box 99014-80107, Mombasa, Kenya</p>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <Phone size={22} />
                                            <p className="text-[18px]">0705 546 231</p>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <Mail size={22} />
                                            <p className="text-[18px]">mbs@mmmnlaw.org</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Text Only */}
                        <div className="flex-1 flex-col h-full items-center justify-center my-0">
                            <div className="flex flex-col px-5 md:px-14 pt-14">
                                <h2 className="text-3xl font-bold text-primary mb-2 uppercase">Send us a message</h2>
                                <p className="text-gray-700 leading-relaxed">Have a question or need legal assistance? 
                                    Send us a message and our team will get back to you promptly.
                                </p>
                            </div>

                            <div className="flex flex-col px-3 pb-10">
                                <ContactForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <Newsletter /> */}
            <NewsletterSection />
        </>
    );
}